import { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import styles from './MobileMenu.module.css';
import {
    MdOutlineDashboard, MdOutlineFastfood, MdPeopleOutline, MdOutlineChat,
    MdCropFree, MdDeliveryDining, MdPrint, MdReceiptLong, MdMoreHoriz, MdLock
} from "react-icons/md";
import { VscLayoutMenubar } from "react-icons/vsc";
import { CiSettings } from "react-icons/ci";
import usePlano from '../hooks/usePlano';

function MobileMenu() {
    const location = useLocation();
    const [maisAberto, setMaisAberto] = useState(false);
    const { temRecurso } = usePlano();

    // Fecha a sheet ao navegar
    useEffect(() => {
        setMaisAberto(false);
    }, [location.pathname]);

    const menuItems = [
        { path: "/admin/gestaoestabelecimento", label: "Visão Geral", icon: <MdOutlineDashboard className={styles.icon}/> },
        { path: "/admin/gerenciamentopedidos", label: "Pedidos", icon: <VscLayoutMenubar className={styles.icon}/> },
        { path: "/admin/gerenciamentocardapio", label: "Cardápio", icon: <MdOutlineFastfood className={styles.icon}/> },
        { path: "/admin/whatsapp", label: "WhatsApp", icon: <MdOutlineChat className={styles.icon}/> }
    ];

    const maisItems = [
        { path: "/cadastromesas", label: "Mesas", icon: <MdCropFree className={styles.icon}/> },
        { path: "/admin/equipe", label: "Equipe", icon: <MdPeopleOutline className={styles.icon}/> },
        { path: "/admin/taxas-entrega", label: "Taxa de Entrega", icon: <MdDeliveryDining className={styles.icon}/> },
        { path: "/admin/impressao", label: "Impressão", icon: <MdPrint className={styles.icon}/> },
        { path: "/admin/fiscal", label: "Fiscal", icon: <MdReceiptLong className={styles.icon}/>, recurso: "fiscal" },
        { path: "/admin/configuracoes", label: "Configurações", icon: <CiSettings className={styles.icon}/> }
    ];

    const maisAtivo = maisItems.some(item => item.path === location.pathname);

    return (
        <>
            {maisAberto && (
                <>
                    <div className={styles.overlay} onClick={() => setMaisAberto(false)} />
                    <div className={styles.sheet}>
                        <span className={styles.sheetTitulo}>Mais opções</span>
                        <div className={styles.sheetGrid}>
                            {maisItems.map(item => {
                                if (item.recurso && !temRecurso(item.recurso)) {
                                    return (
                                        <span
                                            key={item.path}
                                            className={`${styles.sheetItem} ${styles.sheetItemBloqueado}`}
                                            aria-disabled="true"
                                            title="Disponível no plano Full Speed"
                                        >
                                            <MdLock className={styles.cadeado} />
                                            <span className={styles.icon}>{item.icon}</span>
                                            <span className={styles.label}>{item.label}</span>
                                        </span>
                                    );
                                }
                                return (
                                <Link
                                    key={item.path}
                                    to={item.path}
                                    className={`${styles.sheetItem} ${location.pathname === item.path ? styles.active : ""}`}
                                >
                                    <span className={styles.icon}>{item.icon}</span>
                                    <span className={styles.label}>{item.label}</span>
                                </Link>
                                );
                            })}
                        </div>
                    </div>
                </>
            )}

            <footer className={styles.footerMenu}>
                {menuItems.map(item => (
                    <div key={item.path} className={styles.menuItem}>
                        <Link
                            to={item.path}
                            className={location.pathname === item.path ? styles.active : ""}
                        >
                            <span className={styles.icon}>{item.icon}</span>
                            <span className={styles.label}>{item.label}</span>
                        </Link>
                    </div>
                ))}

                <div className={styles.menuItem}>
                    <button
                        type="button"
                        onClick={() => setMaisAberto(aberto => !aberto)}
                        className={`${styles.maisBtn} ${maisAtivo || maisAberto ? styles.active : ""}`}
                    >
                        <span className={styles.icon}><MdMoreHoriz className={styles.icon}/></span>
                        <span className={styles.label}>Mais</span>
                    </button>
                </div>
            </footer>
        </>
    );
}

export default MobileMenu;
